import { useTranslation } from 'react-i18next';
import { LiliRadioInput, LiliRadioInputVariant, LiliTextArea } from '@lili/lili-frontend-common';
import { ControllerWrapper } from '@Hooks/index';
import { FieldError } from '@Components/inputs/FieldError';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';
import { IntendedUseOptions } from './hooks/useIntendedUseLogic';

interface IntendedUseFormProps {
  reactiveOption: string;
  optionsList: {
    value: string;
    getLabel: () => string;
  }[];
}

export const IntendedUseForm = ({ reactiveOption, optionsList }: IntendedUseFormProps) => {
  const { t } = useTranslation('eddQuestions');
  const isOtherSelected = reactiveOption === IntendedUseOptions.OTHER;

  return (
    <div className='flex flex-col gap-[16px]'>
      <ControllerWrapper name={EddEmbeddedFields.EDD_INTENDED_USE}>
        {({ onChange, value, error }) => (
          <>
            {optionsList.map((option) => (
              <LiliRadioInput
                key={option.value}
                label={option.getLabel()}
                id={option.value}
                value={option.value}
                onChange={() => onChange(option.value)}
                checked={value === option.value}
                name={EddEmbeddedFields.EDD_INTENDED_USE}
                variant={LiliRadioInputVariant.DOT}
              />
            ))}
            <FieldError error={error} testId={`${EddEmbeddedFields.EDD_INTENDED_USE}-error`} />
          </>
        )}
      </ControllerWrapper>

      {isOtherSelected && (
        <ControllerWrapper name={EddEmbeddedFields.EDD_INTENDED_USE_OTHER_FREE_TEXT}>
          {({ onChange, value, error, onBlur }) => (
            <LiliTextArea
              value={value}
              onValueChange={onChange}
              errorMsg={error?.message || ''}
              externalErrorMessage={error?.message || ''}
              maxLength={100}
              minHeight='min-h-[88px]'
              placeholder={t(
                'organic.intendedUse.otherPlaceholder',
                'Please specify your intended use...'
              )}
              onBlur={onBlur}
            />
          )}
        </ControllerWrapper>
      )}
    </div>
  );
};
